import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";


const apiKey = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";

const PincodeModal = ({ showModal, setShowModal }) => {
  const [pincode, setPincode] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);
  const appName = sessionStorage.getItem("appName");
  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");
  const handleSubmit = async () => {
    if (!pincode || pincode.trim() === "") {
      setError("Please enter address or pincode");
      return;
    }

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address: pincode,
            key: apiKey,
          },
        }
      );

      if (response.data.status === "OK") {
        const addressComponents =
          response.data.results[0].address_components;

        const postalCode = addressComponents.find((c) =>
          c.types.includes("postal_code")
        )?.long_name;

        const city = addressComponents.find(
          (c) =>
            c.types.includes("locality") ||
            c.types.includes("administrative_area_level_2")
        )?.long_name;

        const state = addressComponents.find((c) =>
          c.types.includes("administrative_area_level_1")
        )?.long_name;

        if (!postalCode) {
          setError("No pincode found for this address");
          return;
        }

        sessionStorage.setItem("userPincode", postalCode);
        if (city) sessionStorage.setItem("userCity", city);
        if (state) sessionStorage.setItem("userState", state);

        setError("");
        setShowModal(false);
        window.location.reload();
      } else {
        setError("Unable to detect address. Please try again.");
      }
    } catch (err) {
      setError("Google lookup failed. Please enter a valid address.");
    }
  };



  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      const savedPincode = sessionStorage.getItem("userPincode");
      if (savedPincode) {
        setPincode(savedPincode);
      }
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  // Google Places Autocomplete
  useEffect(() => {
    if (window.google && inputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        { types: ["geocode"] }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.address_components) {
          setError("Unable to retrieve address details.");
          return;
        }

        const addressComponents = place.address_components;

        // Broaden pincode detection to include possible variations
        const postalCodeComponent = addressComponents.find((c) =>
          c.types.some((type) =>
            ["postal_code", "postal_code_suffix"].includes(type)
          )
        );
        const postalCode =
          postalCodeComponent?.long_name || postalCodeComponent?.short_name;

        const city = addressComponents.find(
          (c) =>
            c.types.includes("locality") ||
            c.types.includes("administrative_area_level_2")
        )?.long_name;
        const state = addressComponents.find((c) =>
          c.types.includes("administrative_area_level_1")
        )?.long_name;

        // Log for debugging
        console.log("Postal Code:", postalCode);
        console.log("Address Components:", addressComponents);

        if (postalCode) {
          setPincode(postalCode);
          sessionStorage.setItem("userPincode", postalCode);
          if (city) sessionStorage.setItem("userCity", city);
          if (state) sessionStorage.setItem("userState", state);
          setError(""); // Clear error message on successful pincode detection
          setShowModal(false);
        } else {
          setError("Selected address doesn't include a pincode.");
        }
      });

      // Adjust the position of the suggestions dropdown
      const inputElement = inputRef.current;
      const autocompleteDropdown = document.querySelector(".pac-container");

      if (autocompleteDropdown) {
        const updateDropdownPosition = () => {
          const inputRect = inputElement.getBoundingClientRect();
          const errorElement = document.querySelector(".error-message");
          const errorHeight = errorElement ? errorElement.offsetHeight : 0;

          autocompleteDropdown.style.top = `${inputRect.bottom + errorHeight + window.scrollY
            }px`;
          autocompleteDropdown.style.left = `${inputRect.left + window.scrollX
            }px`;
          autocompleteDropdown.style.width = `${inputRect.width}px`;
        };

        inputElement.addEventListener("focus", updateDropdownPosition);
        window.addEventListener("resize", updateDropdownPosition);

        return () => {
          inputElement.removeEventListener("focus", updateDropdownPosition);
          window.removeEventListener("resize", updateDropdownPosition);
        };
      }
    }
  }, [showModal]);

  const fetchLocation = async () => {
    try {
      const position = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(resolve, reject)
      );
      const { latitude, longitude } = position.coords;
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
      );

      const addressComponents = response.data.results.flatMap(
        (result) => result.address_components
      );

      const postalCode = addressComponents.find((c) =>
        c.types.includes("postal_code")
      )?.long_name;
      const city = addressComponents.find(
        (c) =>
          c.types.includes("locality") ||
          c.types.includes("administrative_area_level_2")
      )?.long_name;
      const state = addressComponents.find((c) =>
        c.types.includes("administrative_area_level_1")
      )?.long_name;

      if (postalCode) {
        setPincode(postalCode);
        sessionStorage.setItem("userPincode", postalCode);
        if (city) sessionStorage.setItem("userCity", city);
        if (state) sessionStorage.setItem("userState", state);

        setError(""); // Clear error message on successful pincode detection
        setShowModal(false);
        window.location.reload();
      } else {
        alert("Unable to detect pincode.");
      }
    } catch (error) {
      alert("Location access denied or failed.");
    }
  };

  
  //    const fetchLocation = async () => {
  //   try {
  //     const position = await new Promise((resolve, reject) =>
  //       navigator.geolocation.getCurrentPosition(resolve, reject)
  //     );

  //     const { latitude, longitude } = position.coords;
  //     const response = await axios.get(
  //       `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
  //     );

  //     const addressComponents = response.data.results.flatMap(
  //       (result) => result.address_components
  //     );

  //     const postalCode = addressComponents.find((c) =>
  //       c.types.includes("postal_code")
  //     )?.long_name;
  //     const city = addressComponents.find(
  //       (c) =>
  //         c.types.includes("locality") ||
  //         c.types.includes("administrative_area_level_2")
  //     )?.long_name;
  //     const state = addressComponents.find((c) =>
  //       c.types.includes("administrative_area_level_1")
  //     )?.long_name;

  //     if (postalCode) {
  //       setPincode(postalCode);
  //       sessionStorage.setItem("userPincode", postalCode);
  //       if (city) sessionStorage.setItem("userCity", city);
  //       if (state) sessionStorage.setItem("userState", state);
  //       setError("");
  //       setShowModal(false);
  //       window.location.reload();
  //     } else {
  //       throw new Error("No pincode found");
  //     }
  //   } catch (error) {
  //     console.warn("Google API failed or location denied. Using fallback...");

  //     //  Static fallback to Pune
  //     const fallbackPincode = "411045";
  //     const fallbackCity = "Pune";
  //     const fallbackState = "Maharashtra";

  //     setPincode(fallbackPincode);
  //     sessionStorage.setItem("userPincode", fallbackPincode);
  //     sessionStorage.setItem("userCity", fallbackCity);
  //     sessionStorage.setItem("userState", fallbackState);

  //     setError("");
  //     setShowModal(false);
  //     window.location.reload();
  //   }
  // };
  if (!showModal) return null;

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-50 backdrop-blur-sm flex items-start justify-center sm:justify-start pt-10 sm:pt-16 px-4 sm:pl-10 ${webFont}`}
    >
      <div className="bg-white px-4 sm:px-6 py-2 sm:py-6 shadow-lg w-full sm:w-[600px] max-w-[95%] sm:max-w-[600px] rounded-lg relative text-center">
        <button
          className="absolute text-gray-500 top-2 right-2 hover:text-red-600"
          onClick={() => setShowModal(false)}
        >
          <FaTimes />
        </button>

        <p className="mb-3 text-xs text-gray-700 sm:text-sm">
          Welcome to{" "}
          <span className="font-medium" style={{ color: themeColor }}>
            {appName}
          </span>
        </p>

        <div className="flex flex-col items-center gap-2 mt-1 mb-2 sm:flex-row sm:items-center sm:gap-3 sm:mb-1">
          <div className="flex items-center gap-2">
            {/* <FaMapMarkerAlt size={22} className="sm:w-6 sm:h-6" style={{ color: themeIconColor }} /> */}
            <button
              onClick={() => {
                fetchLocation();
                setError("");
              }}
              className="px-3 py-2 text-xs font-medium text-white rounded sm:px-4 sm:text-sm"
              style={{ backgroundColor: themeColor }}
            >
              Detect my Location
            </button>
          </div>

          <div className="text-xs font-medium text-gray-500 sm:mx-1">OR</div>

          <input
            ref={inputRef}
            type="text"
            placeholder="Type your address or pincode"
            className="border rounded px-3 py-2 w-full sm:w-[300px] text-xs sm:text-sm"
            onChange={(e) => {
              setPincode(e.target.value);
              setError("");
            }}
          />
        </div>
        <button
          onClick={handleSubmit}
          className="px-4 py-2 mt-3 text-xs font-medium text-white rounded sm:text-sm"
          style={{ backgroundColor: themeColor }}
        >
          Submit
        </button>


        {/* Error message positioned below the input field */}
        {error && <p className="mt-1 text-xs text-red-500 error-message">{error}</p>}
      </div>
    </div>

  );
};

export default PincodeModal;